/**
 * Privacy Policy page.
 * Presents DeepThink's Privacy Policy content with clear sections and typography.
 * Update whenever the official Privacy Policy text or effective date changes.
 */
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container } from '@mui/material';

import PrivacyPolicyContent from '@/components/enrollment/PrivacyPolicyContent';

interface LocationState {
  from?: string;
  returnTo?: string;
}

function PrivacyPolicyPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location?.state as LocationState | null;
  const cameFromPendingApproval = state?.from === 'pending-approval';
  const returnTo = state?.returnTo || '/';
  return (
    <>
      <Helmet>
        <title>Privacy Policy | DeepThink</title>
      </Helmet>
      <Container
        className="safe-mobile-all"
        maxWidth="md"
        sx={{ py: { xs: 3, sm: 6 } }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {cameFromPendingApproval && (
            <Box sx={{ mb: 1 }}>
              <Button
                size="small"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(returnTo, { replace: true })}
                sx={{ textTransform: 'none', px: 0 }}
              >
                Back to Activation
              </Button>
            </Box>
          )}
          <PrivacyPolicyContent />
        </Box>
      </Container>
    </>
  );
}

export default PrivacyPolicyPage;
